import styled from 'styled-components';

import { Colors } from 'components/utils/styles/ui';
import { Button as ButtonBase } from 'components/elements/button';

import { ButtonGroup } from './index';

export { Wrapper, LoadingContainer } from './index';

export const MFATitle = styled.h4`
  font-size: 2rem;
  font-weight: 500;
  color: ${Colors.tealDark};
`;

export const Section = styled.div`
  margin-bottom: 2rem;
`;

export const QRContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 2rem 0;
`;

export const QRImage = styled.img`
  width: 20rem;
  height: 20rem;
  border: 1px solid ${Colors.grey};
  border-radius: 0.4rem;
  image-rendering: auto;
`;

export const SecretCode = styled.div`
  background-color: ${Colors.headerBG};
  padding: 1rem;
  border-radius: 0.4rem;
  font-family: monospace;
  font-size: 1.1rem;
  text-align: center;
  margin: 1rem 0;
  user-select: all;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
`;

export const CopyButton = styled(ButtonBase)`
  font-size: 1.2rem;
  padding: 0.25rem 0.75rem;
  text-decoration: underline;
`;

export const Instructions = styled.p`
  color: ${Colors.text};
  margin-bottom: 1rem;
`;

export const ToggleButton = styled(ButtonBase)`
  margin: 1rem auto;
  font-size: 1.2rem;
  display: block;
`;

export const ExtendedButtonGroup = styled(ButtonGroup)<{ alignEnd?: boolean }>`
  justify-content: ${({ alignEnd }) =>
    alignEnd ? 'flex-end' : 'space-between'};
  padding-top: 2rem;
  border-top: 1px solid ${Colors.outline};
`;
